import { useRequest } from "hooks";
import type { ID, ResourceResponse, ThunkReturnType } from "types";
import { ApiRouteTypes } from "consts/enpoints/api";
import useExportTable from "hooks/useExportTable";
import type { BankingSdkRecipient, BankingSdkRecipientsResponse } from "../types";
import {
    createBankingSdkRecipientThunk,
    deleteBankingSdkRecipientThunk,
    getBankingSdkRecipientsThunk,
    updateBankingSdkRecipientThunk
} from "../thunks";
import { changeExportBankingSdkRecipientsLoading as changeExportLoading } from "../slice";

export const useBankingSDKRecipientsActions = () => {
    const getBankingSdkRecipients = useRequest<
        ThunkReturnType<BankingSdkRecipientsResponse>,
        string | undefined
    >({
        thunk: getBankingSdkRecipientsThunk
    });

    const createBankingSdkRecipient = useRequest<
        ThunkReturnType<ResourceResponse<BankingSdkRecipient>>,
        Partial<BankingSdkRecipient>
    >({
        thunk: createBankingSdkRecipientThunk
    });

    const updateBankingSdkRecipient = useRequest<
        ThunkReturnType<ResourceResponse<BankingSdkRecipient>>,
        Partial<BankingSdkRecipient>
    >({
        thunk: updateBankingSdkRecipientThunk
    });

    const deleteBankingSdkRecipient = useRequest<
        ThunkReturnType<ResourceResponse<ID>>,
        Pick<BankingSdkRecipient, 'coreId'>
    >({
        thunk: deleteBankingSdkRecipientThunk
    });

    const downloadCsv = useExportTable({
        changeExportLoading,
        apiResourceType: ApiRouteTypes.GetBankingSdkRecipients
    });

    return {
        getBankingSdkRecipients,
        createBankingSdkRecipient,
        updateBankingSdkRecipient,
        deleteBankingSdkRecipient,
        downloadCsv
    };
};

export default useBankingSDKRecipientsActions;
